module.exports = __webpack_public_path__ + "img/noresult.392f755f.png";